import React from "react";
import ContactIcon from "../../assets/icons/contacts_main.svg2";
import GroupsIcon from "../../assets/icons/groups.svg2";
import PageNavLinks from "../Common/PageNavLinks";
import AssetsIcon from "../../assets/icons/asset-01.svg2";
import MapsIcon from "../../assets/icons/mapping.svg2";
import EventsIcon from "../../assets/icons/Icon_Library/application icons/assets/events.svg2";
import SchedulersIcon from "../../assets/icons/Icon_Library/application icons/general/scheduling.svg2";

export const assetsLinks = [
  {
    label: "Contacts",
    Icon: ContactIcon,
    href: "/assets/contacts/all",
  },
  {
    label: "Groups",
    Icon: GroupsIcon,
    href: "/assets/contacts/groups",
  },

  {
    label: "Assets",
    Icon: AssetsIcon,
    href: "/assets/assets",
  },
  {
    label: "Maps",
    Icon: MapsIcon,
    href: "/assets/maps",
  },
  {
    label: "Events",
    Icon: EventsIcon,
    href: "/assets/events",
    // newFeature: true,
  },
  {
    label: "Schedulers",
    Icon: SchedulersIcon,
    href: "/assets/schedulers",
    // newFeature: true,
  },
];

export default function AssetsLinks({ rightSide }: { rightSide: any }) {
  return <PageNavLinks pageName="assets" links={assetsLinks} />;
}
